import { cssVarV2 } from '@streamlain/theme/v2';

export const contextChipThemeVars = `
  --ai-context-chip-height: 28px;
  --ai-context-chip-radius: 6px;
  --ai-context-chip-padding-x: 6px;
  --ai-context-chip-border: ${cssVarV2.layer.insideBorder.border};
  --ai-context-chip-bg: ${cssVarV2.layer.background.primary};
  --ai-context-chip-bg-hover: ${cssVarV2.layer.background.hoverOverlay};
  --ai-context-chip-color: ${cssVarV2.text.primary};
  --ai-context-chip-icon: ${cssVarV2.icon.primary};
  --ai-context-chip-icon-secondary: ${cssVarV2.icon.secondary};
`;
